(() => {
  if (window.ciAccessibilityInstalled) return;
  window.ciAccessibilityInstalled = true;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  function setup(root = document) {
    root.querySelectorAll('.ci-nav-group').forEach(group => {
      if (group.dataset.ciAccessible) return;
      group.dataset.ciAccessible = 'true';
      const summary = group.querySelector('summary');
      group.addEventListener('keydown', event => {
        if (event.key === 'Escape' && group.open) {
          group.open = false; summary.focus();
          event.preventDefault(); event.stopPropagation();
        }
      });
      group.addEventListener('focusout', () => setTimeout(() => {
        if (!group.contains(document.activeElement)) group.open = false;
      }, 0));
    });
    root.querySelectorAll('.ci-preview-mobile').forEach(menu => {
      if (menu.dataset.ciAccessible) return;
      menu.dataset.ciAccessible = 'true';
      const summary = menu.querySelector('summary');
      menu.addEventListener('toggle', () => summary.setAttribute('aria-label', menu.open ? 'Chiudi menu' : 'Apri menu'));
      menu.addEventListener('keydown', event => {
        if (event.key === 'Escape' && menu.open) {
          menu.open = false; summary.focus(); event.preventDefault();
        }
      });
      menu.addEventListener('focusout', () => setTimeout(() => {
        if (!menu.contains(document.activeElement)) menu.open = false;
      }, 0));
    });
    root.querySelectorAll('[data-ci-motion]').forEach(video => {
      if (video.dataset.ciAccessible) return;
      video.dataset.ciAccessible = 'true';
      const container = video.closest('.ci-motion-video');
      const button = document.createElement('button');
      button.type = 'button'; button.className = 'ci-video-control';
      const description = container.classList.contains('ca-hero')
        ? 'lavorazione della pelle'
        : container.closest('.ca-craft')
          ? 'collezione Cuoieria Italiana'
          : 'identità italiana';
      video.setAttribute('aria-label', 'Video: ' + description);
      let visible = false, userPaused = false, userStarted = false;
      let loaded = document.readyState === 'complete';
      const mobileAutoplay = video.dataset.ciMobileAutoplay === 'true';
      const continuous = video.dataset.ciContinuous === 'true';
      function label() {
        button.textContent = video.paused ? 'Riproduci video' : 'Pausa video';
        button.setAttribute('aria-label', button.textContent + ': ' + description);
      }
      function update() {
        const permitted = userStarted || (loaded && !reduced.matches && !navigator.connection?.saveData && (continuous || mobileAutoplay || !matchMedia('(max-width: 749px)').matches));
        if ((visible || continuous) && !document.hidden && !userPaused && permitted) {
          video.play().catch(label);
        } else video.pause();
        label();
      }
      button.addEventListener('click', () => {
        if (video.paused) { userPaused = false; userStarted = true; visible = true; }
        else { userPaused = true; userStarted = false; }
        update();
      });
      window.addEventListener('load', () => { loaded = true; setTimeout(update, 100); }, {once:true});
      video.addEventListener('play', label); video.addEventListener('pause', label);
      if (!continuous) container.append(button);
      label();
      const controller = new AbortController();
      document.addEventListener('visibilitychange', update, {signal:controller.signal});
      reduced.addEventListener('change', () => {userStarted = false; update();}, {signal:controller.signal});
      const observer = new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting; update();
      }, {threshold:0.1});
      observer.observe(video);
      const section = video.closest('.shopify-section');
      const unload = event => {
        if (event.target === section || event.target.contains(video)) {
          observer.disconnect(); controller.abort(); video.pause();
          document.removeEventListener('shopify:section:unload', unload);
        }
      };
      document.addEventListener('shopify:section:unload', unload);
    });
  }
  document.addEventListener('pointerdown', event => {
    document.querySelectorAll('.ci-preview-mobile[open], .ci-nav-group[open]').forEach(menu => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  document.addEventListener('shopify:section:load', event => setup(event.target));
  setup();
})();

/* Desktop product gallery: cross-fade alternate images only while a card is hovered. */
(() => {
  if (window.ciProductHoverGalleryInstalled) return;
  window.ciProductHoverGalleryInstalled = true;
  const precisePointer = matchMedia('(hover:hover) and (pointer:fine)');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  if (!precisePointer.matches || reduced.matches) return;
  const mediaSelector = ':is(.ci-approved,.ci-collection-cards) .ca-card .ca-media';
  const states = new WeakMap();
  function images(media) { return [...media.querySelectorAll('.ci-product-gallery-image')]; }
  function show(media, index) {
    const list = images(media);
    const image = list[index];
    if (!image) return;
    if (!image.src && image.dataset.ciSrc) image.src = image.dataset.ciSrc;
    const commit = () => {
      if (states.get(media)?.index !== index) return;
      list.forEach((item, itemIndex) => item.classList.toggle('is-ci-product-active', itemIndex === index));
    };
    if (image.complete) commit(); else image.addEventListener('load', commit, {once:true});
  }
  function stop(media) {
    const state = states.get(media);
    if (state) { clearTimeout(state.delay); clearInterval(state.interval); }
    states.delete(media);
    images(media).forEach((image, index) => image.classList.toggle('is-ci-product-active', index === 0));
  }
  function start(media) {
    const list = images(media);
    if (list.length < 2 || states.has(media)) return;
    list.slice(1).forEach(image => { if (!image.src && image.dataset.ciSrc) image.src = image.dataset.ciSrc; });
    const state = {index:0, delay:0, interval:0};
    states.set(media, state);
    state.delay = setTimeout(() => {
      state.index = 1; show(media, state.index);
      state.interval = setInterval(() => {
        state.index = (state.index + 1) % list.length;
        show(media, state.index);
      }, 1250);
    }, 320);
  }
  document.addEventListener('pointerover', event => {
    const media = event.target.closest(mediaSelector);
    if (media && !media.contains(event.relatedTarget)) start(media);
  }, {passive:true});
  document.addEventListener('pointerout', event => {
    const media = event.target.closest(mediaSelector);
    if (media && !media.contains(event.relatedTarget)) stop(media);
  }, {passive:true});
})();

/* Lightweight, progressive reveals: one observer, transforms only, no scroll loop. */
(() => {
  if (window.ciDynamicsInstalled) return;
  window.ciDynamicsInstalled = true;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  if (reduced.matches || !('IntersectionObserver' in window)) return;
  const selectors = [
    '.ci-approved .ca-manifesto > *',
    '.ci-approved .ca-categories > a',
    '.ci-approved .ca-catalog-head > *',
    '.ci-approved .ca-filters',
    '.ci-approved .ca-craft-copy > *',
    '.ci-approved .ca-soul > div > *',
    '.ci-approved .ca-services > div',
    'body .ci-story-approved .about-hero > *',
    'body .ci-story-approved .generation > *',
    'body .ci-story-approved .journey > *',
    'body .ci-story-approved .leather-copy > *',
    'body .ci-story-approved .iseo > *',
    'body .ci-story-approved .about-quote > *',
    'body .shopify-policy__container',
    'body .ci-collection-cards .ca-card',
    'body .product__media-wrapper',
    'body .product__info-wrapper',
    'body .cart-items',
    'body .cart__footer'
  ];
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-ci-visible');
      observer.unobserve(entry.target);
    });
  }, {rootMargin:'0px 0px -8% 0px', threshold:.08});
  function watch(node, index = 0) {
    if (!node || node.dataset.ciReveal) return;
    node.dataset.ciReveal = 'true';
    node.classList.add('ci-reveal');
    if (node.matches('.ca-categories > a, .ca-services > div, .ci-collection-cards .ca-card')) node.classList.add('ci-reveal-scale');
    if (node.matches('.product__media-wrapper')) node.classList.add('ci-reveal-left');
    if (node.matches('.product__info-wrapper')) node.classList.add('ci-reveal-right');
    node.style.setProperty('--ci-reveal-delay', `${Math.min(index % 6, 5) * 55}ms`);
    if (node.getBoundingClientRect().top < innerHeight * .9) node.classList.add('is-ci-visible');
    else observer.observe(node);
  }
  function setup(root = document) {
    selectors.forEach(selector => root.querySelectorAll(selector).forEach((node, index) => watch(node, index)));
    root.querySelectorAll('.ci-approved .ca-grid').forEach(grid => {
      grid.querySelectorAll('.ca-card').forEach((card, index) => watch(card, index));
      if (grid.dataset.ciDynamics) return;
      grid.dataset.ciDynamics = 'true';
      new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => {
        if (node.nodeType === 1 && node.matches('.ca-card')) watch(node, [...grid.children].indexOf(node));
      }))).observe(grid, {childList:true});
    });
  }
  document.documentElement.classList.add('ci-dynamics-ready');
  setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));

  /* Depovia-inspired hero depth, active only on capable desktop devices. */
  const hero = document.querySelector('.ci-approved .ca-hero');
  const heroMedia = hero?.querySelector('video');
  const desktop = matchMedia('(min-width: 990px)');
  let parallaxFrame = 0;
  function drawHeroDepth() {
    parallaxFrame = 0;
    if (!heroMedia) return;
    if (reduced.matches || !desktop.matches || navigator.connection?.saveData) {
      heroMedia.style.transform = '';
      return;
    }
    const rect = hero.getBoundingClientRect();
    if (rect.bottom <= 0 || rect.top >= innerHeight) return;
    const shift = Math.max(-34, Math.min(34, -rect.top * .065));
    heroMedia.style.transform = `translate3d(0,${shift}px,0) scale(1.045)`;
  }
  function queueHeroDepth() {
    if (!parallaxFrame) parallaxFrame = requestAnimationFrame(drawHeroDepth);
  }
  if (heroMedia) {
    heroMedia.style.willChange = 'transform';
    window.addEventListener('scroll', queueHeroDepth, {passive:true});
    window.addEventListener('resize', queueHeroDepth, {passive:true});
    reduced.addEventListener('change', queueHeroDepth);
    desktop.addEventListener('change', queueHeroDepth);
    queueHeroDepth();
  }
})();
